import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { LoggerService } from '../services/logger.service';
import { UserRole } from '../shared/types/role.interface';
import { readActiveTunnelData } from '../shared/utils/impersonation-handoff.util';

/**
 * Guard that protects tunnel routes by validating a persisted tunnel token and role.
 */
@Injectable({
  providedIn: 'root',
})
export class TunnelGuard implements CanActivate {
  private router = inject(Router);
  private logger = inject(LoggerService);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const tunnelData = typeof window !== 'undefined' ? readActiveTunnelData() : null;

    if (!tunnelData || !tunnelData['token']) {
      this.logger.info(
        'Access denied - No valid tunnel token',
        { route: state.url },
        'TunnelGuard'
      );
      this.router.navigate(['/tunnel/login']);
      return false;
    }

    if (tunnelData['role'] !== UserRole.TUNNEL) {
      this.logger.warn(
        'Access denied - Not a tunnel user',
        { role: tunnelData['role'] },
        'TunnelGuard'
      );
      this.router.navigate(['/tunnel/login']);
      return false;
    }

    this.logger.debug('Access granted - Tunnel user', { route: state.url }, 'TunnelGuard');
    return true;
  }
}
